export enum EmployeeRole {
  supervisor = 'supervisor',
  expert = 'expert',
}
